let pendingHomeFeedRevalidate = false;

export function markHomeFeedRevalidate() {
  pendingHomeFeedRevalidate = true;
}

export function consumeHomeFeedRevalidate(): boolean {
  const value = pendingHomeFeedRevalidate;
  pendingHomeFeedRevalidate = false;
  return value;
}
